import { Router } from '@angular/router';
import { AuthenticationService } from './services/authentication.service';
import { SessionService } from './services/session.service';
var AuthGuard = (function () {
    function AuthGuard(router, authService, sessionService) {
        this.router = router;
        this.authService = authService;
        this.sessionService = sessionService;
    }
    AuthGuard.prototype.canActivate = function (route, state) {
        if (this.authService.isLoggedIn()) {
            this.sessionService.start();
            // Require to change password first
            if (localStorage.getItem('require_to_change_password') === 'true' && state.url !== '/profile/password') {
                this.router.navigate(['/profile', 'password']);
                return false;
            }
            return true;
        }
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
    };
    return AuthGuard;
}());
export { AuthGuard };



// WEBPACK FOOTER //
// /opt/app/src/app/auth-guard.service.ts.pre-build-optimizer.js